export {
  Colors,
  Shadow,
  Backgrounds,
  useGlobalStyles,
  useGlobalTextStyles,
  useGlobalText,
  createInputsWrapper,
  AntSwitch,
  globalModals,
} from './globalStylesUi';
export { Images } from './images';
export { EmailValidator, PasswordValidator } from './validation';
export { RoutingAllListNew } from './routers';
export {
  PermissionsList,
  paginate,
  filterByFirstName,
  initAxiosInterceptors,
  activeInactive,
  searchByType,
  sortByAz,
  ToastSuccess,
  ToastFail,
  FindSuccess,
  FindSuccessItem,
  FindLoad,
  FindError,
  FindErrorItem,
  SavePage,
  SendPageSave,
  PascalCase,
  RolePermission,
  officeManager,
  branchManager,
  textResizer,
  format,
  useModal,
  AllModals,
  ModalProvider,
  makeCapitalize,
  DownloadFile,
  SaveParams,
  AllSecondaryModals,
  SecondaryModalProvider,
  useSecondaryModal,
  usePrimaryModal,
  PrimaryModal,
  PrimaryModalProvider,
  useTertiaryModal,
  TertiaryModal,
  TertiaryModalProvider,
  getStars,
  calculateReviews,
  handleGetAgingDate,
  handleReturnAgingColor,
  sortListByKey,
} from './hooks';
export { ErrorText } from './errorTexts';
export { CountryList } from './jsons';
export {
  ACCOUNT_ENUMS,
  ACCOUNT_ENUMS_FOR_DRAW,
  docTypes,
  isNotEmpty,
  userType,
  userInfo,
  CheckEdit,
  SubmittedLoadStatus,
  RenderStatus,
  Status,
  RenderEquipmentType,
  isAgent,
  isAdmin,
  isFactored,
  docTypesSwitch,
} from './constants';
export { loadProfit } from './helpers';
export { reserveReleasedEnum, reserveReleasedRender, reserveReleasedList } from './enumValues';

export const fileMaxSize = 10 * 1024 * 1024;
